import { ReactNode } from "react";

interface IButtonProps {
  children: ReactNode;
  type?: "button" | "submit";
  onClick?: () => void;
  disabled?: boolean;
  styles?: string;
}

const DownloadButton = ({
  children,
  onClick,
  disabled,
  styles,
  type = "button",
  ...props
}: IButtonProps) => {
  return (
    <button
      className={` border border-app-blue text-app-blue bg-transparent hover:bg-app-blue hover:text-white rounded-full px-4 py-2 transition ${styles} `}
      onClick={onClick}
      disabled={disabled}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
};

export default DownloadButton;
